import AuthBgWrapper from '@/features/auth/components/auth-bg-wrapper'
import AuthCardWrapper from '@/features/auth/components/auth-card-wrapper'
import ResetPasswordForm from '@/features/auth/components/reset-password/reset-password-form'
import ResetPasswordFormProvider from '@/features/auth/components/reset-password/reset-password-form-provider'
import { createNewPasswordScreenBgImage } from '@/features/auth/constants/image'
import { UrlSearchParams } from '@/shared/types'
import React from 'react'

import { useSearchParams } from 'next/navigation'

function ResetPasswordPage() {
    const searchParams = useSearchParams()
    const email = searchParams.get('email') as string
    const token = searchParams.get('token') as string

    // if(!email || !token) {
    //     redirect(PAGE_ROUTES.login)
    // }

    return (
        <AuthBgWrapper image={createNewPasswordScreenBgImage}>
            <AuthCardWrapper
                headerTitle='Create New Password'
                headerDescription='Providing your details and get started in just a few steps!'
            >
                <ResetPasswordFormProvider email={email} token={token}>
                    <ResetPasswordForm />
                </ResetPasswordFormProvider>
            </AuthCardWrapper>
        </AuthBgWrapper>
    )
}

export default ResetPasswordPage